import { render } from "./InvestmentCard.vue?vue&type=template&id=7795fc38&scoped=true"
import script from "./InvestmentCard.vue?vue&type=script&lang=js"
export * from "./InvestmentCard.vue?vue&type=script&lang=js"

import "./InvestmentCard.vue?vue&type=style&index=0&id=7795fc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7795fc38"]])

export default __exports__